import {html, css, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import {ifDefined} from "lit/directives/if-defined.js";
import {containerStyles, moduleSpacingStyles, normalizeStyles} from "@webs/components-library/theming";

@customElement('webs-quote-card')
export class QuoteCard extends LitElement {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    css`
    .m-quote-card {
      display: block;
      height: 18rem;
      perspective: 300rem;
      -moz-perspective: 300rem;
      position: relative;

   }

    .m-quote-card__side {
     display: flex;
     flex-direction: column;
     transition: all 1s ease;
     width: 100%;
     backface-visibility: hidden;
     color: var(--color-white);
     height: 18rem;
     padding: 1.5rem;
   }

   .m-quote-card__side-back {
      overflow: hidden;
   }

   .m-quote-card__side-front {
      background: var(--color-light-grey);
      border-radius: 0.8rem;
      color: black;
   }

   .m-quote-card__side-back {
      background: linear-gradient(
      216.4deg,
      var(--color-orange) 22.12%,
      var(--color-pink) 110.96%
    );
      color: white;
      border-radius: 0.8rem;
      transform: rotateY(180deg);
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
   }

    .m-quote-card__side-description {
      font-family: var(--font-family-alternative);
      font-size: 0.9rem;
      line-height:1.5;
      margin-top: 2rem;
      margin-bottom: 0;
      max-height: 9.8rem;
      overflow: auto;
      height: 100%;
    }

    .link-arrow::part(link-arrow) {
      color: white;
    }

    .link-arrow::part(circle) {
      fill: white;
    }

    .image {
      border-radius: 50%;
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

   .flipped.m-quote-card__side-front  {
       transform: rotateY(-180deg);
     }

   .flipped.m-quote-card__side-back  {
      transform: rotateY(0);
    }

    .m-quote-card__quoter-info {
      font-family: var(--font-family-alternative);
     }

     .m-quote-card__quoter {
        display: flex;

     }

     .m-quote-card__quoter-info {
       text-align: left;
       margin-left: 0.8rem;
     }

      .m-quote-card__quoter--avatar {
       display: block;
       width: 2rem;
       height: 2rem;
     }

    .m-quote-card__quoter-info--name {
      font-weight: var(--font-weight-strong);
      font-size: 0.7rem;
      line-height: 1.3;
      margin: 0;
      text-transform: uppercase;
    }

    .m-quote-card__quoter-info--extra-info {
      margin: 0;
      font-size: 0.6rem;
      line-height: 1.1rem;
    }

  .m-quote-card .link_arrow {
    font-weight: var(--font-weight-strong);
    font-size: 0.8rem;
    line-height: 0.95rem;
    text-decoration: none;
    color: var(--color-white);
  }

  .m-quote-card .link_arrow svg {
    margin-left: 1.15;
  }

  .active .m-quote-card__side-front  {
    cursor: pointer;
    transform: rotateY(-180deg);
  }

  .active .m-quote-card__side-back  {
    transform: rotateY(0);
  }

  @media only screen and (min-width: 992px){

     .m-quote-card__side-front {
        display: flex;
        flex-direction: column;
        height: 100%;
     }

     .m-quote-card__side-description { font-size: 1.05rem; }

     .m-quote-card:hover .m-quote-card__side-front  {
      cursor: pointer;
      transform: rotateY(-180deg);
    }

    .m-quote-card:hover .m-quote-card__side-back  {
      transform: rotateY(0);
    }
  }
    `]

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 992px)');

  @state()
  private isDesktop: boolean;


  @property({attribute: 'quoter-name'})
  quoterName: string;

  @property()
  description: string;

  @property({attribute: "logo-white"})
  logoWhite: string;

  @property({attribute: "logo-black"})
  logoBlack: string;

  @property({attribute: 'avatar-src'})
  avatarSrc: string;

  @property({attribute: 'avatar-alt'})
  avatarAlt: string;

  @property({attribute: 'extra-info'})
  extraInfo: string;

  @property({attribute: 'link-title'})
  linkTitle: string;

  @property({attribute: 'link-href'})
  linkHref: string;

  connectedCallback() {
    super.connectedCallback();
    this.smallDevice.addEventListener('change', (e) => this.handleDeviceChange(e));
  }


  protected render(): unknown {
    this.handleDeviceChange(this.smallDevice);
    this.addPartAttribute()
    return html`
          <div class="m-quote-card">
            <div class="m-quote-card__side m-quote-card__side-front"
                >
            <img src="${ifDefined(this.logoBlack)}" alt="Logo" loading="lazy" width="90">
            ${this.description ? html`<p class="m-quote-card__side-description">${this.description}</p>` : ''}
             <div class="m-quote-card__quoter">
          ${this.avatarSrc ? html`
            <picture class="m-quote-card__quoter--avatar">
              <img src="${this.avatarSrc}" alt="${this.avatarAlt}" class="image" loading="lazy" width="40"/>
            </picture>
          ` : ''
          }
          <div class="m-quote-card__quoter-info">
            ${this.quoterName ? html`<p class="m-quote-card__quoter-info--name">${this.quoterName}</p>` : ''}
            ${this.extraInfo ? html`<p class="m-quote-card__quoter-info--extra-info">${this.extraInfo}</p>` : ''}
          </div>
        </div>
            </div>
            <div class="m-quote-card__side m-quote-card__side-back"
               >
            <img src="${ifDefined(this.logoWhite)}" alt="Logo" loading="lazy" width="90">
            ${this.description ? html`<p class="m-quote-card__side-description">${this.description}</p>` : ''}

            ${ this.linkTitle ? html`
              <webs-link-arrow class="link-arrow" href="${this.linkHref}" text="${this.linkTitle }"></webs-link-arrow>
           `:""}
            </div>
          </div>
      `
  }



  private handleDeviceChange(event): void {
    this.isDesktop = event.matches;
    this.requestUpdate();
  }

  private addPartAttribute(): void {
    if (this.isDesktop) {
      return;
    }
    document.addEventListener('DOMContentLoaded', evt => {
      const frontSide: HTMLElement = this.shadowRoot.querySelector('.m-quote-card__side-front');
      const backSide: HTMLElement = this.shadowRoot.querySelector('.m-quote-card__side-back');
      frontSide.setAttribute('part', 'front-side')
      backSide.setAttribute('part', 'back-side')

      backSide.addEventListener('click', evt => {
        frontSide.removeAttribute('part')
        backSide.removeAttribute('part')
      })
      frontSide.addEventListener('click', evt => {
        frontSide.setAttribute('part', 'front-side')
        backSide.setAttribute('part', 'back-side')
      })

    })

  }
}
